<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
                :to="{ path: '/system_Management/system_management_home' }"
                >系统管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>消息信息</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">消息筛选</span>
                </el-col>
            </el-row>
            <el-form
                :model="queryForm"
                class="filter_Form"
                label-width="120px"
                ref="queryFormRef"
            >
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item label="赛季" prop="season">
                            <el-select
                                placeholder="请选择类型"
                                style="width: 100%"
                                v-model="queryForm.season"
                            >
                                <el-option
                                    v-for="item in dict_season"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="赛区" prop="districtId">
                            <el-select
                                placeholder="请选择"
                                v-model="queryForm.districtId"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in dict_district"
                                    :key="item.id"
                                    :label="item.districtName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否处理" prop="state">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.state"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_state"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="类型" prop="types">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="queryForm.types"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_types"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" type="flex" justify="end">
                    <el-col :span="2">
                        <el-button
                            type="primary"
                            style="width: 100%"
                            @click="getAllLogsList('search')"
                            >查询</el-button
                        >
                    </el-col>
                    <el-col :span="2">
                        <el-button
                            type="primary"
                            plain
                            style="width: 100%"
                            @click="reset"
                            >重置</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <!-- 问题列表 -->
        <el-card class="list_card" style="margin-top: 20px">
            <el-row class="title_row">
                <el-col :span="12">
                    <div class="list_title title_class">消息列表</div>
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                border
                stripe
            >
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column
                    label="问题描述"
                    prop="describe"
                ></el-table-column>
                <el-table-column label="图片信息" prop="files" width="150">
                    <template slot-scope="scope">
                        <div
                            class="image-list"
                            v-if="getImageList(scope.row.files).length > 0"
                        >
                            <div
                                v-for="(file, index) in getImageList(
                                    scope.row.files
                                )"
                                :key="index"
                                class="file-item"
                            >
                                <!-- 图片 -->
                                <el-image
                                    v-if="isImage(file)"
                                    :src="file"
                                    :preview-src-list="
                                        getImageList(scope.row.files).filter(
                                            f => isImage(f)
                                        )
                                    "
                                    fit="cover"
                                    class="image-thumb"
                                ></el-image>
                                <!-- 视频 -->
                                <div
                                    v-else-if="isVideo(file)"
                                    class="video-thumb"
                                    @click="playVideo(file)"
                                >
                                    <i class="el-icon-video-play"></i>
                                    <span class="video-label">视频</span>
                                </div>
                            </div>
                        </div>
                        <span v-else class="no-image">无图片</span>
                    </template>
                </el-table-column>
                <el-table-column label="问题类型" prop="type"></el-table-column>
                                <el-table-column label="赛区" prop="districtName"></el-table-column>
                <el-table-column label="处理状态" prop="state">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.state == true"
                            >已处理</el-tag
                        >
                        <el-tag type="danger" v-else>未处理</el-tag>
                    </template></el-table-column
                >
                <el-table-column label="反馈" prop="reply"></el-table-column>
                <el-table-column
                    label="联系人信息"
                    prop="contactName"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.contactName }}(<MaskedPhone :phone="scope.row.contactPhone" />)</span>
                    </template>
            </el-table-column>
                <el-table-column
                    label="注册信息"
                    prop="phone"
                >
                 <template slot-scope="scope">
                        <span>{{ scope.row.userName }}(<MaskedPhone :phone="scope.row.phone" />)</span>
                    </template>
            </el-table-column>
                <el-table-column
                    label="创建时间"
                    prop="submitTime"
                ></el-table-column>
                <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="mini"
                            @click="changeStateDetailData(scope.row.id)"
                            >标记</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </el-card>
        <!--  -->
        <el-dialog
            title="是否处理"
            :visible.sync="messageDialogVisible"
            width="40%"
            @close="messageDialogVisibleClose"
        >
            <el-form
                label-width="110px"
                :model="messageForm"
                :rules="messageFormRules"
                ref="messageFormRef"
            >
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="messageForm.reply"
                        >
                        </el-input>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="messageDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="saveMessageClicked"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 视频播放对话框 -->
        <el-dialog
            title="视频播放"
            :visible.sync="videoDialogVisible"
            width="60%"
            center
            @close="closeVideoDialog"
        >
            <div class="video-preview-container">
                <video
                    v-if="currentVideoUrl"
                    ref="videoPlayer"
                    :src="currentVideoUrl"
                    controls
                    class="video-player"
                ></video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { wordFeedbackList, wordFeedbackReply, queryDistrictPage } from '@/http/api'
export default {
  data () {
    return {
      messageDialogVisible: false,
      dataList: [],
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      // 视频播放相关
      videoDialogVisible: false,
      currentVideoUrl: '',
      dateTimeRange: [],
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        season: '',
        types: 'orderQuestion'
      },
      messageFormRules: {
        textarea: [{ required: true, message: '请输入反馈信息', trigger: 'blur' }]
      },
      messageForm: {
      },
      total: 0,
      dict_state: this.$userInfo.isHandle(),
      dict_types: [{
        dictCode: 4,
        dictLabel: '订单问题',
        dictValue: 'orderQuestion'
      }]
    }
  },
  created () {
    this.getAllLogsList()
    this.getDistrictList()
  },
  methods: {
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        console.log('this.editInfoForm', this.editInfoForm)
        if (this.editInfoForm.id) {
          this.getSchoolContactsData()
        }
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getAllLogsList (type) {
      if (type === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      wordFeedbackList(this.queryForm).then((res) => {
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    goBack () {
      this.$router.back()
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getAllLogsList('search')
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getAllLogsList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getAllLogsList()
    },
    changeStateDetailData (messageId) {
      this.messageDialogVisible = true
      this.messageForm.id = messageId
    },
    saveMessageClicked () {
      wordFeedbackReply(this.messageForm).then((res) => {
        this.messageDialogVisible = false
        this.$message.success('保存成功！')
        this.getAllLogsList()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    messageDialogVisibleClose () {
      this.$refs.messageFormRef.resetFields()
    },
    // 解析图片JSON字符串为数组
    getImageList (files) {
      if (!files) {
        return []
      }
      try {
        // 如果已经是数组，直接返回
        if (Array.isArray(files)) {
          return files
        }
        // 如果是字符串，尝试解析JSON
        if (typeof files === 'string') {
          const parsed = JSON.parse(files)
          return Array.isArray(parsed) ? parsed : []
        }
        return []
      } catch (e) {
        console.error('解析图片JSON失败:', e)
        return []
      }
    },
    // 判断是否是图片
    isImage (url) {
      if (!url || typeof url !== 'string') {
        return false
      }
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg']
      const lowerUrl = url.toLowerCase()
      return imageExtensions.some(ext => lowerUrl.includes(ext))
    },
    // 判断是否是视频
    isVideo (url) {
      if (!url || typeof url !== 'string') {
        return false
      }
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv']
      const lowerUrl = url.toLowerCase()
      return videoExtensions.some(ext => lowerUrl.includes(ext))
    },
    // 播放视频
    playVideo (videoUrl) {
      this.currentVideoUrl = videoUrl
      this.videoDialogVisible = true
    },
    // 关闭视频对话框
    closeVideoDialog () {
      // 停止视频播放
      this.$nextTick(() => {
        const videoElement = this.$refs.videoPlayer
        if (videoElement) {
          videoElement.pause()
          videoElement.currentTime = 0
        }
      })
      this.currentVideoUrl = ''
    }
  }
}
</script>

<style scoped>
.a-btn {
    color: #409eff;
    font-size: 14px;
}
.row {
    display: flex;
    margin-bottom: 12px;
}
/* 图片列表样式 */
.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.file-item {
    position: relative;
}
.image-thumb {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;
}
.image-thumb:hover {
    border-color: #409eff;
    transform: scale(1.05);
}
/* 视频缩略图样式 */
.video-thumb {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    position: relative;
}
.video-thumb:hover {
    border-color: #409eff;
    background-color: #ecf5ff;
    transform: scale(1.05);
}
.video-thumb i {
    font-size: 20px;
    color: #409eff;
    margin-bottom: 2px;
}
.video-label {
    font-size: 10px;
    color: #606266;
}
.no-image {
    color: #909399;
    font-size: 12px;
}
/* 视频播放器样式 */
.video-preview-container {
    text-align: center;
    padding: 20px;
}
.video-player {
    width: 100%;
    max-width: 100%;
    max-height: 70vh;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
